<template>
  <StatisticsCard title="Post Categories" content-classes="py-6">
    <template #content>
      <div class="flex flex-wrap w-full items-center justify-center gap-6">
        <Doughnut
          ref="cwCategoriesChart"
          chart-id="'cwCategoriesChart'"
          :chart-data="cwCategoriesChartData"
          :chart-options="cwCategoriesChartOptions"
          css-classes="relative z-10"
          :width="120"
          :height="120"
        />
        <div class="flex flex-col capitalize">
          <div
            v-for="(category, index) in cwCategoriesKeys"
            :key="category"
            class="flex items-center justify-start gap-2"
          >
            <span
              :class="['w-3 h-3 rounded-full']"
              :style="{
                'background-color': cwCategoriesChartColors[index],
              }"
            />
            <p class="text-sm">
              {{ category }} {{ cwCategoriesKeysCounts[index] }}
            </p>
          </div>
        </div>
      </div>
    </template>
  </StatisticsCard>
</template>

<script>
import { defineComponent, computed, ref, watch } from 'vue'
import { useStore } from '../../../js/store/index.js'
import { formatNumber } from '../../../js/util/helper.js'
import StatisticsCard from './StatisticsCard.vue'
import { Doughnut } from 'vue-chartjs/legacy'
import { Chart as ChartJS, ArcElement, CategoryScale } from 'chart.js'

export default defineComponent({
  name: 'StatisticsCardPostCategories',

  components: {
    Doughnut,
    StatisticsCard,
  },

  props: {
    context: {
      type: String,
      default: 'CAREERWISE',
    },
  },

  setup(props) {
    const store = useStore()
    ChartJS.register(ArcElement, CategoryScale)

    const context = props.context
    const storeGetterMap = {
      CAREERWISE: 'contributors/get',
      ORGANISATION: 'contributors/getOrganisationActivity',
    }
    const storeGetterPrefix = computed(() => storeGetterMap[context])

    const cwCategoriesKeys = computed(() => {
      const data = store.getters[`${storeGetterPrefix.value}PostCategories`]
      return Object.keys(data)
    })

    const cwCategoriesKeysCounts = computed(() => {
      const data = store.getters[`${storeGetterPrefix.value}PostCategories`]
      return Object.values(data)
    })

    const cwCategoriesTotalCount = computed(() => {
      return store.getters[`${storeGetterPrefix.value}PostCategoriesCount`]
    })

    const cwCategoriesChartColors = ['#6F36BC', '#A986D7', '#FF4778']
    const cwCategoriesChartOptions = {
      responsive: true,
      maintainAspectRatio: true,
      cutout: '68%',
    }

    const cwCategoriesChartData = computed(() => {
      return {
        labels: cwCategoriesKeys.value,
        datasets: [
          {
            backgroundColor: cwCategoriesChartColors,
            data: cwCategoriesKeysCounts.value,
          },
        ],
      }
    })

    const cwCategoriesChart = ref(null)
    watch(cwCategoriesChart, (val) => {
      if (val) {
        const cwCategoriesTotalCountElHTML = `
          <div class="absolute inset-0 flex flex-col justify-center items-center">
            <span class="text-xl text-cw-700">
              ${formatNumber(cwCategoriesTotalCount.value)}
            </span>
            <span class="text-xs">
              Total
            </span>
          </div>
        `

        const cwCategoriesTotalCountEl = document.createElement('div')
        cwCategoriesTotalCountEl.innerHTML = cwCategoriesTotalCountElHTML

        cwCategoriesChart.value.$el.insertAdjacentElement(
          'beforeend',
          cwCategoriesTotalCountEl,
        )
      }
    })

    return {
      cwCategoriesKeys,
      cwCategoriesKeysCounts,
      cwCategoriesTotalCount,
      cwCategoriesChart,
      cwCategoriesChartColors,
      cwCategoriesChartData,
      cwCategoriesChartOptions,
    }
  },
})
</script>
